import http from '../utils/httpRequest';
// 场地信息维护列表（仅限超管）
const infoBaseList = (params) => {
  return http.post('/field/manages/list', { ...params })
}
const getEvalRoomInfo = (params) => {
  return http.get('/field/manages/getEvalRoomInfo?tradeOrgId=' + params)
}
const stepsFinished = (params) => {
  return http.get('/field/manages/stepsFinished?orgId=' + params)
}
// 场地信息维护--基本信息维护
const infoBaseSave = (params) => {
  return http.post('/field/manages/save', { ...params })
}
// 场地信息维护--场地楼层维护
const infoFloorList = (params) => {
  return http.post('/field/floors/list', { ...params })
}
const infoFloorDetail = (params) => {
  return http.get('/field/floors/get?id=' + params)
}
const infoFloorSave = (params) => {
  return http.post('/field/floors/save', { ...params })
}
const infoFloorDelete = (params) => {
  return http.post('/field/floors/delete', { ...params })
}
// 场地信息维护--场地信息维护
const infoMaintainList = (params) => {
  return http.post('/field/info/list', { ...params })
}
const infoMaintainDetail = (params) => {
  return http.get('/field/info/get?id=' + params)
}
const infoMaintainSave = (params) => {
  return http.post('/field/info/save', { ...params })
}
const infoMaintainDelete = (params) => {
  return http.post('/field/info/delete', { ...params })
}
const infoMaintainSelect = (params) => {
  return http.get('/field/info/getEvalRoomOptions?tradeOrgId=' + params)
}
// 场地信息维护--机位信息维护
const infoSeatList = (params) => {
  return http.post('/field/seats/list', { ...params })
}
const infoSeatDetail = (params) => {
  return http.get('/field/seats/get?id=' + params)
}
const infoSeatSave = (params) => {
  return http.post('/field/seats/save', { ...params })
}
const infoSeatDelete = (params) => {
  return http.post('/field/seats/delete', { ...params })
}
// 场地信息维护--监控信息维护
const infoMonitorList = (params) => {
  return http.post('/field/cameras/list', { ...params })
}
const infoMonitorDetail = (params) => {
  return http.get('/field/cameras/get?id=' + params)
}
const infoMonitorSave = (params) => {
  return http.post('/field/cameras/save', { ...params })
}
const infoMonitorDelete = (params) => {
  return http.post('/field/cameras/delete', { ...params })
}




// 场地总览
export {
  infoBaseList, // 场地信息维护超管列表
  getEvalRoomInfo,
  stepsFinished,
  infoBaseSave, // 基本信息维护
  infoMaintainList, // 场地信息维护列表
  infoMaintainDetail, // 场地信息维护编辑详情
  infoMaintainSave, // 场地信息维护保存
  infoFloorList, // 场地楼层维护列表
  infoFloorDetail, // 场地楼层维护编辑详情
  infoFloorSave, // 场地楼层维护保存
  infoFloorDelete,
  infoMaintainDelete, // 场地信息维护删除
  infoMaintainSelect, // 场地下拉选择
  infoSeatList, // 机位信息维护列表
  infoSeatDetail, // 机位信息维护编辑详情
  infoSeatSave, // 机位信息维护保存
  infoSeatDelete, // 机位信息维护删除
  infoMonitorList, // 监控信息维护列表
  infoMonitorDetail, // 监控信息维护编辑详情
  infoMonitorSave, // 监控信息维护保存
  infoMonitorDelete, // 监控信息维护删除
}
